module.exports = function (next) {

	// JS you want to run on every page load / transition...
	// Note: You must reference (next) at the end of your require so you can access the new container in your included functions.

	// Example: require('../common/sample.js')(next)

}
